((Drupal) => {
  "use strict";

  // Adds custom CSS classes to login links based on their query parameter values.
  const loginLinkClass = (context) => {
    const links = context.querySelectorAll("form.user-login-form a");
    if (!links.length) return;

    const appClassMap = {
      Google: "google-link",
      Microsoft: "microsoft-link",
      MyLogin: "mylogin-link",
    };

    links.forEach((link) => {
      const linkURL = link.getAttribute("href");
      if (linkURL) {
        Object.entries(appClassMap).forEach(([appName, className]) => {
          if (linkURL.includes(`appname=${appName}`)) {
            link.classList.add(className);
          }
        });
      }
    });
  };

  Drupal.behaviors.loginLinkClass = {
    attach(context) {
      loginLinkClass(context);
    },
  };
})(Drupal);
